import React from 'react'
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import $ from 'jquery';
import {renderFieldMonetarioLabelEncima, required} from '../../util/inputs';
import cadastrarValorPesoEncomenda from '../../actions/empresa/cadastrarConfiguracaoEncomenda';
import {showSuccessMsg} from '../../util/messagesUtil';

export class ModalCadastroValorPesoEncomenda extends React.Component {
  constructor (props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  fecharModal () {
    $('#modalCadastrarValorPeso')
      .modal('hide');
    $('#modalCadastrarValorPeso')
      .hide();
    $('.modal-backdrop')
      .hide();
  }

  submit (values) {
    this.props.cadastrarValorPesoEncomenda(this.props.empresaSelecionada.id, values.valorPeso.replace('R$', ''))
      .then(() => {
          showSuccessMsg('Valor alterado com sucesso');
          this.fecharModal();
      })
  }


  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (
      <div className="modal fade show" id='modalCadastrarValorPeso' role='dialog'
           aria-labelledby='modalCadastrarValorPeso' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-sm'}>
          <div className="modal-content">
            <div className="modal-header">
              <h5>Valor do KG da encomenda</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <i className="material-icons">
                  &#xe5cd;
                </i>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(this.submit)}>
                <div className="col-12 col-sm-12 col-md-12">
                  <Field name='valorPeso' validate={[required]} component={renderFieldMonetarioLabelEncima} className="form-control" label="Valor:"/>
                </div>
                <div className="modal-footer mt-4">
                  <button id='cancelar' type="button" className="btn btn-outline-secondary"
                          data-dismiss="modal">Cancelar
                  </button>
                  <button type="submit" disabled={invalid || submitting || pristine}
                          className="btn btn-laranja">Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps (state) {
  return {
    empresaSelecionada: state.empresaSelecionada,
    initialValues: {
      valorPeso: state.empresaSelecionada.valorKgEncomenda,
    }
  }
}

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    cadastrarValorPesoEncomenda
  }, dispatch)
);


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioCadastroValorPeso',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ModalCadastroValorPesoEncomenda));
